import { CollectionEntity } from "@busy-human/gearbox";
export var Invoices;
(function (Invoices_1) {
    function Defaults() {
        const now = new Date().toISOString();
        return {
            companyId: "",
            date: now.substring(0, now.indexOf("T")),
            amount: 0,
            number: "",
            paidOn: null
        };
    }
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return Defaults();
        }
        async getInvoicesForCompany(companyId) {
            const docs = await this.subset((ref, query) => query.where("companyId", "==", companyId).toQuery()).fetch();
            return docs.map(d => d.data());
        }
    }
    Invoices_1.CollectionClass = CollectionClass;
    Invoices_1.Invoices = new CollectionClass({ path: "/Invoices" });
})(Invoices || (Invoices = {}));
//# sourceMappingURL=index.js.map